export enum FinishReadingDialogEnum {
    RESTART = 'RESTART',
    OPEN_FORM = 'OPEN_FORM',
    DASHBOARD = 'DASHBOARD'
}
